/* eslint-disable import/no-named-as-default */
import {combineReducers} from 'redux';
import stepBlockReducer from './stepsBlock/stepsBlock.reducer';
import navigationReducer from './navigation/navigation.reducer';

export const STEPSBLOCK_REDUCER = 'stepsblock';
export const NAVIGATION_REDUCER = 'navigation';

export const getAllReducers = () => combineReducers({
    [STEPSBLOCK_REDUCER]: stepBlockReducer,
    [NAVIGATION_REDUCER]: navigationReducer
});
